import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerComponiFatturaPAConfirmModalComponent } from './worker-componi-fattura-pa-confirm-modal';

export const WorkerComponiFatturaPAConfirmModalModule: string = ng
    .module('worker-componi-fattura-pa-confirm-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerComponiFatturaPAConfirmModalComponent', WorkerComponiFatturaPAConfirmModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/worker-componi-fattura-pa-confirm-modal/worker-componi-fattura-pa-confirm-modal.module.ts